import { productsAndServicesApi } from 'api';
import { ProductServiceResponse } from 'pco-product-service-internal-consumer';

export const getProductsServices = async (partnerNumber: string): Promise<ProductServiceResponse> => {
  return await productsAndServicesApi.getProspectProductsAndServices({ partnerUid: partnerNumber });
};
